export default __webpack_public_path__ + "static/media/taiyang-zhang.76fb08fe.svg";